module.exports = function (source, length = 3) {
  source = String(source).split(".");
  source[0] = source[0].replace(new RegExp('(\\d)(?=(\\d{'+length+'})+$)','ig'),"$1,");
  return source.join(".");
}


// WEBPACK FOOTER //
// ./~/vux/src/tools/number/comma.js